import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { DashboardDataSchemas, ExecutionJobLogSchema } from "../ea.schema";

const base = "dashboard";
const dash = createEndpointBase(base);

export const dashboardEndpoints = {
  dashboardDiskUsage: dash({
    method: "GET",
    path: "disk-usage",
    request: z.looseObject({}),
    response: DashboardDataSchemas.diskUsage,
    description: "Retrieves disk usage statistics for the system.",
  }),
  dashboardRecentlyExecutedScripts: dash({
    method: "GET",
    path: "recently-executed-scripts",
    request: z.object({ take: z.coerce.number().optional() }).optional(),
    response: z.any(),
    description: "Retrieves a list of recently executed automation scripts.",
  }),
  dashboardSchedulerStats: dash({
    method: "GET",
    path: "scheduler-stats",
    request: z.object({ schedulerJobId: z.coerce.number(), take: z.coerce.number().optional() }),
    response: z.array(ExecutionJobLogSchema),
    description: "Retrieves execution statistics for schedulers.",
  }),
  dashboardPlannedSchedulers: dash({
    method: "GET",
    path: "planned-schedulers",
    request: z.any(),
    response: z.array(DashboardDataSchemas.plannedScheduler),
    description: "Retrieves a list of upcoming planned scheduler executions.",
  }),
} as const;
